module.exports = __webpack_public_path__ + "img/help-active.f23a342e.svg";